<template>
  <div v-if="userData">
    <CRow>
      <CCol lg="12" v-if="userData.adminlogin_role == 8">
        <CCard>
          <CCardHeader class="bg-yellow text-black"> จัดการชุดแบบทดสอบ </CCardHeader>
          <CCardBody>
            <TblAllExam/>
          </CCardBody>
          <CCardFooter class="text-right">
          </CCardFooter>
        </CCard>
      </CCol>
      <CCol lg="12" v-if="userData.adminlogin_role == 8">
        <CCard>
          <CCardHeader class="bg-yellow text-black"> Export คำตอบ </CCardHeader>
          <CCardBody>
            <SltTest />
          </CCardBody>
          <CCardFooter class="text-right">
            <button
              class="btn btn-yellow"
              @click="onExportSat"
              v-if="spinerSat == false"
              :disabled="isDisabled"
            >
              export
            </button>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import MainChartExample from "./charts/MainChartExample";
import WidgetsDropdown from "./widgets/WidgetsDropdown";
import WidgetsBrand from "./widgets/WidgetsBrand";
import WidgetsStat from "./widgets/WidgetsStat";
import SltTest from "./components/SltTest";

import TblAllExam from "./components/TblAllExam";



import XLSX from "xlsx"; // import xlsx

export default {
  name: "Dashboard",
  components: {
    MainChartExample,
    WidgetsDropdown,
    WidgetsBrand,
    WidgetsStat,
    SltTest,
    TblAllExam,
    XLSX,
  },
  data() {
    return {
      userData: this.$cookies.get("user"),
      wholeTeacherInfo: null,
      btnDisable: false,
      spinerState: false,
      spinerSat: false,
      pretestProcessing: 1,
      scoreToExcel: null,
      isDisabled:false
    };
  },
  mounted() {
    //console.log(this.userData);
  },
  methods: {
    onExportWholeTeacher() {
      this.btnDisable = true;
      this.spinerState = true;

      this.axios
        .get(
          this.$hostUrl +
            "php_action/userAPI.php?txtAction=getTeacher&sltRegion=All"
        )
        .then((response) => {
          console.log(response.data);
          //COMMIT STORE NEW DATA
          this.wholeTeacherInfo = response.data.mainData;
          this.btnDisable = false;
          this.spinerState = false;
          //this.rows = response.data.mainData;
          //console.log(response.data);
          const dataWS = XLSX.utils.json_to_sheet(this.wholeTeacherInfo);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, dataWS);
          XLSX.writeFile(wb, "exportWholeTrainee.xlsx");
        })
        .finally(() => {});
    },
    onExportSat() {
      if(!this.$store.state.selectedTest){
        alert("โปรดระบุแบบทดสอบ");
        return false;
      }
      this.isDisabled = true;
      //FETCH TEACHER IN COURSE
      this.axios
        .get(this.$hostUrl + "php_action/exportDataAPI.php?txtAction=getAnswerPretestJSON&courseId="+this.$store.state.selectedTest.code)
        .then((response) => {
          //Excel Action
          const dataWS = XLSX.utils.json_to_sheet(response.data.mainData);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, dataWS);
          XLSX.writeFile(wb, "export.xlsx");
           this.isDisabled = false;
        });
    },
    scoringPretest() {
      this.pretestProcessing = 2;
      //FETCH TEACHER IN COURSE
      this.axios
        .get(
          this.$hostUrl +
            "php_action/scoringAPI.php?txtAction=updateScoringByCenter&testType=pretest&centerId=" +
            this.userData.adminlogin_center_id
        )
        .then((response) => {
          alert("ตรวจคำตอบเสร็จแล้ว");
          location.reload();
        })
        .finally(() => {});
    },
  },
};
</script>
